import { c as _c } from "react/compiler-runtime";
import { useAssociatedJiraIssue } from '@/data/jira/use-associated-issue';
import { useJiraIntegration } from '@/data/jira/use-jira-integration';

/**
 * The Jira issue linked to a pull request, with the connection gating the PR page sidebar and
 * the /code PR tab share. Null while the installation has no Jira connection with a cloud site;
 * the linked-issue request waits for the connection.
 */
export function useLinkedJiraIssue(t0) {
  const $ = _c(5);
  const {
    owner,
    repo,
    pullNumber,
    installationId
  } = t0;
  const {
    connection
  } = useJiraIntegration(installationId ?? undefined);
  const connectionId = connection?.nangoConnectionId;
  const cloudId = connection?.cloudId;
  const t1 = !!connectionId;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      enabled: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const associatedIssue = useAssociatedJiraIssue(owner, repo, pullNumber, t2);
  if (!connectionId || !cloudId || !installationId) {
    return null;
  }
  let t3;
  if ($[2] !== associatedIssue || $[3] !== installationId) {
    t3 = {
      ...associatedIssue,
      installationId
    };
    $[2] = associatedIssue;
    $[3] = installationId;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}